import numeral from "numeral";

export const showInIQD = (value, showCurr, realCurr, returnValue) => {
  if (realCurr === "USD") {
    if (showCurr === "USD") {
      if (returnValue) {
        return value;
      } else {
        return numeral(value).format("$0,00.00");
      }
    }
    value = value * 1.48 * 1000;
  }

  if (showCurr === "USD") {
    if (realCurr === "IQD") value = value / 1480;
  }
  if (showCurr === "USD" && !returnValue) {
    return numeral(value).format("$0,00.00");
  }

  if (returnValue) return value;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: showCurr || "IQD",
    minimumFractionDigits: 0,
  }).format(value);
};
